export const home = {
  'Made for': 'Made for',
  'New releases': 'New releases',
  MUSIC: 'Music',
  ALL: 'All',
  PODCASTS: 'Podcasts',
  ARTISTS: 'Artists',
  SONGS: 'Songs',
  ALBUMS: 'Albums',
  TRACKS: 'Songs',
  PLAYLISTS: 'Playlists',
  you: 'you',
  'Made for you': 'Made for you',
};
